import React, { useState } from 'react';
import { Search, Users, Calendar, FileText, Edit, Eye, ChevronDown } from 'lucide-react';
import useGroupProjectManagementStore from '@/stores/AdminStore/GroupProjectManagementStore';
import './ProjectList.css';

const ProjectList = () => {
  const { projects } = useGroupProjectManagementStore();

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');

  const filteredProjects = projects?.filter(project => {
    const matchesSearch = project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = selectedStatus === 'all' || project.status === selectedStatus;
    return matchesSearch && matchesStatus;
  }) || [];

  return (
    <div className="admin-group-project-list-container">
      <div className="admin-group-project-list-wrapper">
        {/* Search and Filter Section */}
        <div className="admin-group-project-filters">
          <div className="admin-group-search-box">
            <Search size={20} className="admin-group-search-icon" />
            <input
              type="text"
              placeholder="Search Projects"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="admin-group-search-input"
            />
          </div>

          <div className="admin-group-filter-dropdown">
            <select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="admin-group-status-select"
            >
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="draft">Draft</option>
              <option value="completed">Completed</option>
            </select>
            <ChevronDown size={20} className="admin-group-dropdown-icon" />
          </div>
        </div>

        {/* Projects Grid */}
        <div className="admin-group-projects-grid">
          {filteredProjects.map((project) => (
            <div key={project.id} className="admin-group-project-card">
              {/* Header with Icon and Status */}
              <div className="admin-group-project-card-header">
                <div className="admin-group-project-icon">
                  <Users size={28} />
                </div>
                <span className={`admin-group-status-badge admin-group-status-${project.status}`}>
                  {project.status}
                </span>
              </div>

              {/* Project Title and Description */}
              <div className="admin-group-project-content">
                <h3 className="admin-group-project-title">{project.name}</h3>
                <p className="admin-group-project-description">{project.description}</p>
              </div>

              {/* Project Details */}
              <div className="admin-group-project-details">
                <div className="admin-group-detail-item">
                  <Calendar size={16} className="admin-group-detail-icon" />
                  <span>Due {project.deadline}</span>
                </div>
                <div className="admin-group-detail-item">
                  <Users size={16} className="admin-group-detail-icon" />
                  <span>{project.teams} teams • {project.membersPerTeam} members each</span>
                </div>
                <div className="admin-group-detail-item">
                  <FileText size={16} className="admin-group-detail-icon" />
                  <span>{project.deliverables} deliverables</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="admin-group-project-actions">
                <button className="admin-group-btn admin-group-btn-view">
                  <Eye size={16} />
                  View
                </button>
                <button className="admin-group-btn admin-group-btn-edit">
                  <Edit size={16} />
                  Edit
                </button>
              </div>

              {/* Footer */}
              <div className="admin-group-project-footer">
                Created {project.created}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectList;